
/**
 * Custom component for Bimini default menu sections.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 2.1.0
 * @copyright  Copyright (C) 2023-2026, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 * @changelog
 *
 *  2023-06-07 (1.0.0) (jhoward)
 *    - Copy from PanchoWillies_defaultSection.vue component to Chi_defaultSection.vue component.
 *
 *  2023-08-18 (1.0.1) (jhoward)
 *    - Add custom intro page CSS to <Chi_defaultSection>.
 *
 *  2023-08-28 (1.1.0) (jhoward)
 *    - Use <menu-version> in <Chi_defaultSection>.
 *
 *  2025-02-11 (1.2.0) (jhoward)
 *    - Add <menu-schedules> to the <Chi_defaultSection> component if in admin view.
 *
 *  2025-04-08 (2.0.0) (jhoward)
 *    - Use <default-textual-section> and <default-visual-section> in <Chi_defaultSection>.
 *    - Add textual and visual menu CSS tweaks to <Chi_defaultSection>.
 *
 * 2026-02-17 (2.1.0) (jhoward)
 *   - Add menuItemComponent prop to App\Library\Js\Components\Menu\Section\Chi_defaultSection.vue to allow dynamic item component selection.
 *   - Add slots for sectionTitleImage and beforeBottomContentArea to support custom section content.
 *   - Update template to use new props and slots, increasing flexibility for section rendering.
 */

import {defineComponent, PropType} from "vue";
import {ALLOWED_ITEM_COMPONENTS, Menu, MenuSection} from "../defs";
import DefaultVisualSection from "./visual/defaultVisualSection.vue";
import DefaultTextualSection from "./textual/defaultTextualSection.vue";

export default defineComponent({
  components: {
    DefaultTextualSection,
    DefaultVisualSection,
  },
  name: "Chi_defaultSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    sectionModifier: {
      type: String,
      default: ''
    },
    menuItemComponent: {
      type: String,
      default: 'chi-default-item',
      validate: (value: string) => '' === value || ALLOWED_ITEM_COMPONENTS.indexOf(value)
    },
  },
  computed: {
    containerClasses: function () {
      return {
        'menu--section-desserts': this.section.ms_title.toLowerCase() === 'desserts',
      };
    }
  },
})
